import { useMemo } from 'react'

import { useGetAccountQuery } from '../store/accountUserSettings/accountUserSettings'
import { selectAccountId } from '../store/auth/authSlice'
import { useAppSelector } from '../store/hooks'

import { stripToText } from './util'

export const useEffectiveConfig = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: accountResponse, isFetching: accountIsFetching } = useGetAccountQuery({ accountId })

  const effectiveConfig = accountResponse?.data?.effectiveConfig
  const complianceConfig = effectiveConfig?.complianceConfig

  const pdfComplianceMessage = useMemo(() => {
    const { enabled: pdfComplianceMessageEnabled, message } = complianceConfig?.pdfComplianceMessage ?? {}

    if (!pdfComplianceMessageEnabled || !message) {
      return null
    }

    return stripToText(message)
  }, [complianceConfig])

  const emailComplianceMessage = useMemo(() => {
    const { enabled: emailComplianceMessageEnabled, message } = complianceConfig?.emailComplianceMessage ?? {}

    if (!emailComplianceMessageEnabled || !message) {
      return null
    }

    return stripToText(message)
  }, [complianceConfig])

  const copyComplianceMessage = useMemo(() => {
    const { enabled: copyComplianceMessageEnabled, message } = complianceConfig?.copyComplianceMessage ?? {}

    if (!copyComplianceMessageEnabled || !message) {
      return null
    }

    return stripToText(message)
  }, [complianceConfig])

  return { effectiveConfig, emailComplianceMessage, pdfComplianceMessage, copyComplianceMessage, accountIsFetching }
}
